import EntryActionTypes from '../constants/EntryActionTypes';

const createListInCurrentBoard = (data) => ({
  type: EntryActionTypes.LIST_IN_CURRENT_BOARD_CREATE,
  payload: {
    data,
  },
});

const handleListCreate = (list) => ({
  type: EntryActionTypes.LIST_CREATE_HANDLE,
  payload: {
    list,
  },
});

const updateList = (id, data) => ({
  type: EntryActionTypes.LIST_UPDATE,
  payload: {
    id,
    data,
  },
});

const handleListUpdate = (list, included) => ({
  type: EntryActionTypes.LIST_UPDATE_HANDLE,
  payload: {
    list,
    included,
  },
});

const moveList = (id, index) => ({
  type: EntryActionTypes.LIST_MOVE,
  payload: {
    id,
    index,
  },
});

const transferList = (id, boardId, index = 0, addUserIds = [], pointSystemOptions = {}) => ({
  type: EntryActionTypes.LIST_TRANSFER,
  payload: {
    id,
    boardId,
    index,
    addUserIds,
    pointSystemOptions,
  },
});

const prepareTransferList = (id, boardId) => ({
  type: EntryActionTypes.LIST_TRANSFER_PREPARE,
  payload: {
    id,
    boardId,
  },
});

const confirmListTransferPointSystem = (enable) => ({
  type: EntryActionTypes.LIST_TRANSFER_POINT_SYSTEM_CONFIRM,
  payload: {
    enable,
  },
});

const cloneList = (id, boardId, navigateAfterClone = false, addUserIds = []) => ({
  type: EntryActionTypes.LIST_CLONE,
  payload: {
    id,
    boardId,
    navigateAfterClone,
    addUserIds,
  },
});

const deleteList = (id) => ({
  type: EntryActionTypes.LIST_DELETE,
  payload: {
    id,
  },
});

const handleListDelete = (list) => ({
  type: EntryActionTypes.LIST_DELETE_HANDLE,
  payload: {
    list,
  },
});

const archiveList = (id) => ({
  type: EntryActionTypes.LIST_ARCHIVE,
  payload: {
    id,
  },
});

const handleListArchive = (list) => ({
  type: EntryActionTypes.LIST_ARCHIVE_HANDLE,
  payload: {
    list,
  },
});

const restoreList = (id) => ({
  type: EntryActionTypes.LIST_RESTORE,
  payload: {
    id,
  },
});

const handleListRestore = (list) => ({
  type: EntryActionTypes.LIST_RESTORE_HANDLE,
  payload: {
    list,
  },
});

export default {
  createListInCurrentBoard,
  handleListCreate,
  handleListRestore,
  restoreList,
  updateList,
  handleListUpdate,
  moveList,
  transferList,
  prepareTransferList,
  confirmListTransferPointSystem,
  cloneList,
  deleteList,
  handleListDelete,
  archiveList,
  handleListArchive,
};
